module.exports = __webpack_public_path__ + "assets/img/free_28.7b6783f7.png";